import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Globe, Plus } from 'lucide-react';

import './Country.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const Country = () => {
    const [submitting, setSubmitting] = useState(false);
    const [data, setData] = useState({
        name: ""
    });

    const [focusedFields, setFocusedFields] = useState({
        name: false
    });

    const navigate = useNavigate();

    const handleFocus = (field) => {
        setFocusedFields(prev => ({ ...prev, [field]: true }));
    };

    const handleBlur = (field) => {
        setFocusedFields(prev => ({ ...prev, [field]: data[field].length > 0 }));
    };

    const onChangeHandler = (event) => {
        const { name, value } = event.target;
        setData(prevData => ({ ...prevData, [name]: value }));
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();

        if (!data.name) {
            toast.error("Country name is required");
            return;
        }

        try {
            setSubmitting(true);

            const response = await axios.post(`${url}/api/country`, data);

            if (response.data.success) {
                toast.success("Country added successfully!");
                setData({ name: "" });
                navigate('/ViewCountry');
            }

        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to add Country";
            toast.error(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="form-wrapper">
            <div className="country-form-container">
                <h2 className="form-title">
                    <Globe size={20} className="inline mr-2" /> Add New Country
                </h2>

                <div className="header">
                    <h2></h2>
                    <button
                        onClick={() => navigate('/ViewCountry')}
                        className="add-button"
                    >
                        <Plus size={16} /> View Country
                    </button>
                </div>

                <form className="country-form" onSubmit={onSubmitHandler}>
                    <div className={`form-field ${focusedFields.name || data.name ? 'filled' : ''}`}>
                        <input
                            type="text"
                            name="name"
                            value={data.name}
                            onChange={onChangeHandler}
                            onFocus={() => handleFocus('name')}
                            onBlur={() => handleBlur('name')}
                            required
                        />
                        <label>Country Name</label>
                    </div>

                    <button
                        type="submit"
                        className="submit-btn"
                        disabled={submitting}
                    >
                        {submitting ? "Processing..." : "Add Country"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Country;